import { render } from "./TypeEditModal.vue?vue&type=template&id=0ec94bea"
import script from "./TypeEditModal.vue?vue&type=script&lang=js"
export * from "./TypeEditModal.vue?vue&type=script&lang=js"
script.render = render

export default script